import request from '@/utils/request'

// 校验商家是否存在接口
export function getQryBusinessByName(data) {
  return request({
    url: '/apis/sra/store/users/signup/qryBusinessByName', // 后端接口
    method: 'post',
    data
  })
}
